<template>
  <div class="large_main">
    <div class="top_title">
      <div class="title_text">电梯智慧云监控</div>
      <div class="time">{{ time }}</div>
    </div>
    <div class="large_content">
      <div class="left">
        <div class="baoyang_success item_box">
          <div class="item_title_box">今日班组保养完成率</div>
          <div class="baoyang_content">
            <div class="baoyang_box">
              <div class="swiper-wrapper">
                <div
                  class="baoyang_list swiper-slide"
                  v-for="(item, index) in maintenanceUserList"
                  :key="index"
                >
                  <div class="list_item">
                    <div class="baoyang_title">
                      {{ item.unitName }}班（{{ item.areaName }}）
                      <div class="baoyang_tag">平均维保时长：{{ item.wbTimeNo }}</div>
                    </div>
                    <div class="baoyang_list_main">
                      <el-progress
                        :stroke-width="10"
                        type="circle"
                        color="#00CB61"
                        :width="70"
                        :percentage="
                          item.planNumber
                            ? ((item.planFinishNumber / item.planNumber) * 100).toFixed(2)
                            : 0
                        "
                        text-color="#fff"
                      ></el-progress>
                      <img class="icon" src="@/assets/other/dengyu.png" alt="" />
                      <div class="tips_box">
                        <div class="tips">
                          计划已完成:<span>{{ item.planFinishNumber }}</span>
                        </div>
                        <div class="line"></div>
                        <div class="tips">
                          计划保养单:<span>{{ item.planNumber }}</span>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <img
                v-if="maintenanceUserList.length == 0"
                class="nothing"
                src="@/assets/image/nothing.png"
                alt=""
              />
            </div>
          </div>
        </div>
        <div class="today_bao item_box">
          <div class="item_title_box">今日保养</div>
          <div class="baoyang_step_box">
            <div class="swiper-wrapper">
              <div
                class="swiper-slide"
                v-for="(item, index) in upKeepDayDetailVo"
                :key="index"
              >
                <div class="today_content">
                  <el-form label-width="80px">
                    <el-row :span="24">
                      <el-col :span="12">
                        <el-form-item label="工单编号:">
                          {{ item.workOrder }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="工单状态:">
                          {{ getStatus(item.orderType) }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="项目名称:">
                          {{ item.wbName }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="签到时间:">
                          {{ item.wbUserTime }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="维保班组:">
                          {{ item.unitName }}
                        </el-form-item>
                      </el-col>
                      <el-col :span="12">
                        <el-form-item label="保养时长:">
                          {{ item.wbTime }}
                        </el-form-item>
                      </el-col>
                    </el-row>
                  </el-form>
                  <div class="step_box">
                    <div class="step_list one">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/wbry.png" alt="" />
                        <div class="step_title">维保人员</div>
                        <div class="line"></div>
                      </div>
                      <div class="step_desc">{{ item.wbUserName }}</div>
                    </div>
                    <div class="step_list two">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/byzp.png" alt="" />
                        <div class="step_title">保养照片</div>
                        <div class="line"></div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 60px; height: 60px"
                          :src="item.wbSignImg"
                          :preview-src-list="[item.onSitePhotos]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                    </div>
                    <div class="step_heng">
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/qianzi.png" alt="" />
                        <div class="step_title">维保签字</div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 48px; height: 48px"
                          :src="item.wbSignImg"
                          :preview-src-list="[item.wbSignImg]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                      <div class="line_box">
                        <div class="line"></div>
                      </div>
                      <div class="step_img_box">
                        <img class="step_icon" src="@/assets/other/qianzi.png" alt="" />
                        <div class="step_title">物业签字</div>
                      </div>
                      <div class="step_desc">
                        <el-image
                          v-if="item.wbSignImg"
                          style="width: 48px; height: 48px"
                          :src="url"
                          :preview-src-list="[item.wySignImg]"
                        />
                        <span style="color: #fff" v-else>暂无</span>
                      </div>
                    </div>
                  </div>
                  <div class="location">
                    <img class="address_icon" src="@/assets/other/location_icon.png" />
                    {{ item.address }}
                  </div>
                </div>
              </div>
            </div>
            <img
              v-if="upKeepDayDetailVo.length == 0"
              class="nothing"
              src="@/assets/image/nothing.png"
              alt=""
            />
          </div>
        </div>
      </div>
      <div class="center">
        <div class="center_top">
          <div class="all_baoyang">
            <el-progress
              :stroke-width="10"
              type="circle"
              color="#00CB61"
              :width="92"
              :percentage="
                formData.planNumber
                  ? ((formData.planFinishNumber / formData.planNumber) * 100).toFixed(2)
                  : 0
              "
              text-color="#fff"
            ></el-progress>
            <img class="icon" src="@/assets/other/by_line.png" alt="" />
            <div class="tips_box">
              <div class="tips">
                计划已完成:<span>{{ formData.planFinishNumber }}</span>
              </div>
              <div class="line"></div>
              <div class="tips">
                计划保养单:<span>{{ formData.planNumber }}</span>
              </div>
            </div>
          </div>
          <div class="info_box">
            <img class="icon" src="@/assets/other/i1.png" alt="" />
            <div class="info_desc">
              <div class="label">超期未保养</div>
              <div class="num">{{ formData.overdueUpkeepNo }}</div>
            </div>
            <img class="line" src="@/assets/other/by_line.png" alt="" />
            <img class="icon" src="@/assets/other/i1.png" alt="" />
            <div class="info_desc">
              <div class="label">合同数</div>
              <div class="num">{{ formData.signatureNo }}</div>
            </div>
          </div>
        </div>
        <div class="center_bottom">
          <div class="anay_box">
            <div class="anay_list">
              <img class="icon" src="@/assets/other/n1.png" alt="" />
              <div class="desc_box">
                <div class="label">维保工总数</div>
                <div class="num">{{ formData.upkeepUserNo }}</div>
              </div>
            </div>
            <div class="anay_list">
              <img class="icon" src="@/assets/other/n2.png" alt="" />
              <div class="desc_box">
                <div class="label">2天未上线</div>
                <div class="num">{{ formData.upTimeNo }}</div>
              </div>
            </div>
          </div>
          <div class="unline_title">
            <img class="icon" src="@/assets/other/unline_icon.png" alt="" />
            <div class="text">维保工超过2天未上线名单</div>
            <img class="icon2" src="@/assets/other/unline_icon2.png" alt="" />
          </div>
          <div class="table_box">
            <el-table
              :data="upkeepUserListVos"
              class="tableSpec"
              style="height: 100%"
              max-height="254"
            >
              <el-table-column align="center" label="姓名" prop="nickName" />
              <el-table-column align="center" label="所属班组" prop="unitName" />
              <el-table-column align="center" label="联系方式" prop="phonenumber" />
              <el-table-column align="center" label="未上线天数" prop="upDayNo" />
            </el-table>
          </div>
        </div>
        <div class="map_box">
          <div class="back" v-if="showBack()" @click="backToProvince"></div>
          <div class="map_content" id="map"></div>
        </div>
      </div>
      <div class="right">
        <div class="hetong_box item_box">
          <div class="item_title_box">维保合同</div>
          <div class="hetong_content">
            <img class="heng_line center_line" src="@/assets/other/h-heng.png" />
            <img class="shu_line center_line" src="@/assets/other/h-shu.png" />

            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h1.png" alt="" />
              <div class="hetong_info">
                <div class="label">已过期</div>
                <div class="num">{{ formData.expiredContractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h2.png" alt="" />
              <div class="hetong_info">
                <div class="label">进行中</div>
                <div class="num">{{ formData.contractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h3.png" alt="" />
              <div class="hetong_info">
                <div class="label">即将到期</div>
                <div class="num">{{ formData.expireContractNo }}</div>
              </div>
            </div>
            <div class="hetong_list">
              <img class="icon" src="@/assets/other/h4.png" alt="" />
              <div class="hetong_info">
                <div class="label">未开始</div>
                <div class="num">{{ formData.notStartedContractNo }}</div>
              </div>
            </div>
          </div>
        </div>
        <div class="baoxian_box item_box">
          <div class="item_title_box">电梯年检&保险</div>
          <div class="baoxian_content">
            <div class="baoxian_top">
              <div class="zongshu">
                <div class="num">{{ formData.yearElevatorNo }}</div>
                <div class="label">在保电梯总数</div>
              </div>
            </div>
            <div class="baoxian_bottom">
              <div class="bao_list">
                <img class="icon" src="@/assets/other/tag.png" />
                <div class="label">年检</div>
                <img class="picture" src="@/assets/other/b1.png" />
                <div class="show_value">
                  <div class="show_list one">
                    年检临期 <span>{{ formData.yearWbNo }}</span>
                  </div>
                  <div class="show_list two">
                    超期未检 <span>{{ formData.overdueNo }}</span>
                  </div>
                  <!-- <div class="show_list three">需复检 <span>50</span></div> -->
                </div>
              </div>
              <div class="bao_list">
                <img class="icon" src="@/assets/other/tag.png" />
                <div class="label">保险</div>
                <img class="picture" src="@/assets/other/b2.png" />
                <div class="show_value">
                  <div class="show_list one">
                    年检临期 <span>{{ formData.insureYearNo }}</span>
                  </div>
                  <div class="show_list two">
                    超期未检 <span>{{ formData.insureOverdueNo }}</span>
                  </div>
                  <!-- <div class="show_list three">需复检 <span>50</span></div> -->
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="large_bottom"></div>
  </div>
</template>

<script>
import { getSmartYun } from "@/api/user";
import { getMapData } from "@/api/user";
import { areaIdMap, areaNameMap, mapDataToEcharts } from "@/utils";

import Swiper from "swiper"; // 注意引入的是Swiper
import * as echarts from "echarts";

import hubeiGeoJson from "@/utils/map.json"; // 湖北省geojson
// 市区geojson示例引入写法（实际建议动态import或按需加载）
import shiyan from "@/utils/cities/shiyan.json";
import shennongjia from "@/utils/cities/shennongjia.json";
import enshi from "@/utils/cities/enshi.json";
import xiangyang from "@/utils/cities/xiangyang.json";
import yichang from "@/utils/cities/yichang.json";
import suizhou from "@/utils/cities/suizhou.json";
import jingmen from "@/utils/cities/jingmen.json";
import jingzhou from "@/utils/cities/jingzhou.json";
import xiaogan from "@/utils/cities/xiaogan.json";
import tianmen from "@/utils/cities/tianmen.json";
import qianjiang from "@/utils/cities/qianjiang.json";
import xiantao from "@/utils/cities/xiantao.json";
import wuhan from "@/utils/cities/wuhan.json";
import huanggang from "@/utils/cities/huanggang.json";
import ezhou from "@/utils/cities/ezhou.json";
import huangshi from "@/utils/cities/huangshi.json";
import xianning from "@/utils/cities/xianning.json";
// import DataCenter from "./dataCenter/index.vue";
// import MonitorCenter from "./monitorCenter/index.vue";
export default {
  name: "ElevatorLargeIndex",
  components: {
    // DataCenter,
    // MonitorCenter,
  },
  data() {
    return {
      maintenanceUserList: [],
      formData: {},
      upKeepDayDetailVo: [],

      url:
        "https://gimg2.baidu.com/image_search/src=http%3A%2F%2Fimage109.360doc.com%2FDownloadImg%2F2025%2F04%2F0321%2F296122601_4_20250403090445718&refer=http%3A%2F%2Fimage109.360doc.com&app=2002&size=f9999,10000&q=a80&n=0&g=0n&fmt=auto?sec=1754030365&t=23cde2530243c9a9130347d2132acb9c",
      time: "",
      upkeepUserListVos: [],

      currentLevel: "province", // 省级或市级
      currentMapName: "hubei", // 当前注册的地图名称
      // url: "wss://lift.yqdiot.cn/websocket/eventMessage",
      // url: "ws://192.168.0.103:8380/websocket/eventMessage",
      // webSocket: null,
      first: true,
      realWarnList: [],
      code: "",
      parentCode: "",
      codeText: "",
      codeList: [
        "420100",
        "420200",
        "420300",
        "420500",
        "420600",
        "420700",
        "420800",
        "420900",
        "421000",
        "421100",
        "421200",
        "421300",
        "422800",
        "429004",
        "429005",
        "429006",
        "429021",
      ],
    };
  },
  created() {},
  mounted() {
    const query = window.location.hash.split("?")[1];
    // 解析 URL 参数
    const urlParams = new URLSearchParams(query);
    const token = urlParams.get("token");
    const code = urlParams.get("code");
    if (code) {
      console.log("App.vue 中获取的 token:", code);
      localStorage.setItem("code", code); // 或存到 Vuex
    }
    if (token) {
      console.log("App.vue 中获取的 token:", token);
      localStorage.setItem("token", token); // 或存到 Vuex
    }
    this.$nextTick(() => {
      this.getData();
      this.getTime();
      this.code = localStorage.getItem("code");
      if (
        this.code == "429004" ||
        this.code == "429005" ||
        this.code == "429006" ||
        this.code == "429021"
      ) {
        this.parentCode = this.code;
      } else {
        this.parentCode = this.code.slice(0, 4) + "00";
      }
      this.codeText = areaIdMap[Number(this.parentCode)] || null;
      if (this.codeText) {
        this.currentLevel = "city";
        this.loadCityMap(this.codeText);
      } else {
        this.initMap();
      }
    });
  },

  methods: {
    showBack() {
      if (this.currentLevel !== "city") {
        return false;
      } else {
        if (this.codeList.includes(this.code)) {
          return true;
        } else {
          return false;
        }
      }
    },
    initMap(mapName = "hubei", geoJson = hubeiGeoJson, mapTitle = "湖北省") {
      const myChart = echarts.init(document.getElementById("map"));
      this.myChart = myChart;
      echarts.registerMap(mapName, geoJson);
      if (this.currentLevel == "province") {
        getMapData({
          areaId: "42",
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
          // 点击事件，切换市区地图
          myChart.off("click");
          myChart.on("click", (params) => {
            if (this.currentLevel === "province") {
              const cityName = params.name;
              this.loadCityMap(cityName);
            }
          });
        });
      } else {
        getMapData({
          areaId: areaNameMap[mapTitle] || mapTitle,
        }).then((res) => {
          const cityData = mapDataToEcharts(res.data, geoJson);
          const option = {
            title: {
              text: mapTitle,
              left: "center",
              textStyle: {
                color: "#fff", // 这里设置你想要的颜色，比如橙色
                fontSize: 18, // 也可以设置字体大小
                fontWeight: "bold", // 加粗（可选）
              },
            },
            tooltip: {
              trigger: "item",
              formatter: function (params) {
                if (params.value) return `${params.name}: ${params.value}`;
                return params.name;
              },
            },
            series: [
              {
                name: mapTitle,
                type: "map",
                map: mapName,
                roam: false,
                zoom: 1.15,
                label: { show: true },
                itemStyle: {
                  areaColor: "#8FB8D6",
                  borderColor: "#404a59",
                },
                emphasis: {
                  label: { show: true, color: "#fff", fontWeight: "bold" },
                  itemStyle: { areaColor: "#f0a31a" },
                },
                data: cityData,
              },
            ],
          };
          myChart.setOption(option);
        });
      }
    },
    loadCityMap(cityName) {
      console.log(cityName, "cityNamecityNamecityName");
      // 市名转拼音映射（示例，建议完善）
      const cityMap = {
        十堰市: { mapName: "shiyan", geoJson: shiyan },
        神农架林区: { mapName: "shennongjia", geoJson: shennongjia },
        恩施土家族苗族自治州: { mapName: "enshi", geoJson: enshi },
        襄阳市: { mapName: "xiangyang", geoJson: xiangyang },
        宜昌市: { mapName: "yichang", geoJson: yichang },
        随州市: { mapName: "suizhou", geoJson: suizhou },
        荆门市: { mapName: "jingmen", geoJson: jingmen },
        荆州市: { mapName: "jingzhou", geoJson: jingzhou },
        孝感市: { mapName: "xiaogan", geoJson: xiaogan },
        天门市: { mapName: "tianmen", geoJson: tianmen },
        潜江市: { mapName: "qianjiang", geoJson: qianjiang },
        仙桃市: { mapName: "xiantao", geoJson: xiantao },
        武汉市: { mapName: "wuhan", geoJson: wuhan },
        黄冈市: { mapName: "huanggang", geoJson: huanggang },
        鄂州市: { mapName: "ezhou", geoJson: ezhou },
        黄石市: { mapName: "huangshi", geoJson: huangshi },
        咸宁市: { mapName: "xianning", geoJson: xianning },
        // 其他市对应json要补充
      };
      const city = cityMap[cityName];
      if (!city) {
        alert("未找到该市的地图数据！");
        return;
      }
      this.currentLevel = "city";
      this.currentMapName = city.mapName;
      if (this.myChart) {
        this.myChart.dispose(); // 销毁原图实例
      }
      this.initMap(city.mapName, city.geoJson, cityName); // 传入市区地图参数
    },
    backToProvince() {
      if (this.currentLevel === "city") {
        this.currentLevel = "province";
        this.currentMapName = "hubei";
        this.myChart.dispose();
        this.initMap("hubei", hubeiGeoJson, "湖北省");
      }
    },
    getData() {
      getSmartYun().then((res) => {
        this.formData = res.data;
        this.maintenanceUserList = res.data?.maintenanceUserList ?? [];
        this.upkeepUserListVos = res.data?.upkeepUserListVos ?? [];
        this.upKeepDayDetailVo = res.data?.upKeepDayDetailVo ?? [];

        this.$nextTick(() => {
          this.swiperInitBaoyang();
          this.swiperInitStep();
        });
      });
    },
    swiperInitStep() {
      new Swiper(".baoyang_step_box", {
        slidesPerView: "1",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    swiperInitBaoyang() {
      new Swiper(".baoyang_box", {
        slidesPerView: "2",
        loop: true, // 循环模式选项
        direction: "vertical", // 垂直切换选项
        autoplay: {
          delay: 3000,
          disableOnInteraction: false,
        }, //可选选项，自动滑动
        spaceBetween: 0,
      });
    },
    getStatus(type) {
      if (type == 1) {
        return "待领取";
      } else if (type == 2) {
        return "进行中";
      } else if (type == 3) {
        return "已完成";
      } else {
        return "-";
      }
    },
    getTime() {
      this.getCurrentDateTime();
      setInterval(() => {
        this.getCurrentDateTime();
      }, 1000);
    },

    getCurrentDateTime() {
      let now = new Date();
      // 获取日期部分
      let year = now.getFullYear();
      let month = (now.getMonth() + 1).toString().padStart(2, "0"); // 月份从0开始，所以要+1
      let day = now.getDate().toString().padStart(2, "0");
      // 获取时间部分
      let hours = now.getHours().toString().padStart(2, "0");
      let minutes = now.getMinutes().toString().padStart(2, "0");
      let seconds = now.getSeconds().toString().padStart(2, "0");
      // 获取星期部分
      let weekDays = ["周日", "周一", "周二", "周三", "周四", "周五", "周六"];
      let weekDay = weekDays[now.getDay()];
      // 组合成目标格式
      this.time = `${year}.${month}.${day} ${hours}:${minutes}:${seconds} ${weekDay}`;
    },
  },
};
</script>
<style scoped lang="scss">
.large_main {
  // width: 1680px;
  // height: 1032px;
  position: relative;
  width: calc(100% - 40px);
  height: 100vh;
  background: url("@/assets/image/big_bg.png") no-repeat center;
  background-size: 100% 100%;
  padding: 0 20px;
  .top_title {
    background: url("@/assets/image/large_top_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 90px;
    position: relative;
    .title_text {
      width: 100%;
      text-align: center;
      padding-top: 6px;
      font-family: YouSheBiaoTiHei;
      font-weight: 400;
      font-size: 40px;
      color: #fff;
      letter-spacing: 4px;
    }
    .time {
      position: absolute;
      margin: auto;
      right: 60px;
      font-family: Microsoft YaHei, Microsoft YaHei;
      font-weight: 700;
      font-size: 18px;
      color: #fff;
      bottom: 16px;
    }
  }

  .large_content {
    height: calc(100% - 154px);
    width: 100%;
    display: flex;
    justify-content: space-between;
    .left {
      width: 480px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      // height: 392px;
      .baoyang_success {
        width: 100%;
        // height: 352px;

        .baoyang_content {
          background: url("@/assets/image/g1.png") no-repeat center;
          background-size: 100% 100%;
          height: 260px;
          width: calc(100% - 40px);
          padding: 10px 20px;
          .baoyang_box {
            height: 100%;
            width: 100%;
            overflow: hidden;

            .baoyang_list {
              padding: 5px auto;
              width: 100%;
              display: flex;
              align-items: center;
              justify-content: center;
              .list_item {
                width: 100%;
                background: rgba(8, 85, 150, 0.29);
                height: 120px;
                padding: 0 10px;
                .baoyang_title {
                  height: 38px;
                  width: 100%;
                  border-bottom: 1px dashed #1e4f7b;
                  font-weight: 700;
                  font-size: 14px;
                  color: #fff;
                  display: flex;
                  align-items: center;
                  justify-content: space-between;

                  .baoyang_tag {
                    padding: 0 10px;
                    height: 24px;
                    line-height: 24px;
                    background: rgba(79, 158, 232, 0.1);
                    box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
                    border-radius: 2px 2px 2px 2px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        135deg,
                        rgba(0, 255, 255, 1),
                        rgba(0, 149.00000631809235, 250.00000029802322, 1),
                        rgba(0, 149.00000631809235, 250.00000029802322, 1)
                      )
                      1 1;
                  }
                }
                .baoyang_list_main {
                  height: 82px;
                  width: 100%;
                  display: flex;
                  align-items: center;
                  justify-content: space-evenly;
                  .icon {
                    width: 20px;
                    height: 10px;
                  }
                  .tips_box {
                    width: 140px;
                    height: 69px;
                    display: flex;
                    flex-direction: column;
                    justify-content: space-between;
                    .tips {
                      background: url("@/assets/other/beijing.png") no-repeat center;
                      background-size: 100% 100%;
                      width: 100%;
                      height: 24px;
                      font-family: Microsoft YaHei, Microsoft YaHei;
                      font-weight: 400;
                      font-size: 12px;
                      color: #c9eaf7;
                      line-height: 24px;
                      span {
                        font-weight: 700;
                        font-size: 12px;
                        color: #09b5ff;
                        margin-left: 5px;
                      }
                    }
                    .line {
                      width: 140px;
                      height: 0px;
                      border-bottom: 1px dashed #6e9cc5;
                    }
                  }
                }
              }
            }
          }
        }
      }
      .today_bao {
        // flex: 1;
        height: calc(100% - 290px);
        margin-top: 10px;
        width: 100%;
        display: flex;
        flex-direction: column;
        align-items: center;
        .baoyang_step_box {
          height: 100%;
          width: 100%;
          // background: url("@/assets/image/g1.png") no-repeat center;
          background: url("@/assets/image/bottom_bg.png") no-repeat center;
          background-size: 100% 100%;
          overflow: hidden;
          .nothing{
            margin-top: 80px;
          }
        }
        .today_content {
          width: calc(100% - 40px);
          padding: 10px 20px;
          flex: 1;
          
          display: flex;
          flex-direction: column;
          justify-content: space-between;
        }
        .step_box {
          width: 100%;

          .step_heng {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            .step_img_box {
              width: 52px;
            }
            .step_desc {
              width: 60px;
              height: 48px;
              margin-left: 17px;
            }
            .line_box {
              height: 52px;
              flex: 1;
              display: flex;
              align-items: center;
              justify-content: center;
              .line {
                height: 0;
                width: 100%;
                border-bottom: 1px dashed #6e9cc5;
              }
            }
          }

          .step_list {
            width: 100%;
            display: flex;
            align-items: flex-start;
            justify-content: space-between;
            &.one {
              height: 88px;
              .step_desc {
                height: 48px;
                width: 328px;
                text-align: left;
                font-weight: 400;
                font-size: 14px;
                color: #fff;
              }
            }
            &.two {
              height: 100px;
              .step_desc {
                width: 328px;
                height: 60px;
                display: flex;
                align-items: center;
              }
            }
            .step_img_box {
              height: 100%;
              display: flex;
              flex-direction: column;
              align-items: center;
              .line {
                flex: 1;
                width: 0px;
                border-left: 1px dashed #6e9cc5;
              }
            }
          }
          .step_desc {
            background: rgba(0, 30, 58, 0.72);
            box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(103, 192, 255, 0.46);
            padding: 10px 20px;
          }
          .step_icon {
            width: 52px;
            height: 52px;
          }
          .step_title {
            font-weight: 700;
            font-size: 12px;
            line-height: 16px;
            background: linear-gradient(90deg, #ffffff 45%, #8ed8ff 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
          }
        }
        .location {
          width: 100%;
          height: 30px;
          background: rgba(79, 158, 232, 0.1);
          box-shadow: inset 0px 0px 20px 0px rgba(0, 149, 250, 0.5);
          border-radius: 2px 2px 2px 2px;
          border: 1px solid;
          border-image: linear-gradient(
              135deg,
              rgba(0, 255, 255, 1),
              rgba(0, 149.00000631809235, 250.00000029802322, 1),
              rgba(0, 149.00000631809235, 250.00000029802322, 1)
            )
            1 1;
          display: flex;
          align-items: center;
          font-weight: 400;
          font-size: 14px;
          color: #fff;
          .address_icon {
            width: 16px;
            height: 16px;
            margin: 0 10px;
          }
        }
      }
    }

    .center {
      width: calc(100% - 980px);
      height: 100%;
      display: flex;
      flex-direction: column;
      align-items: flex-end;
      justify-content: space-between;
      position: relative;
      .center_top {
        width: 100%;
        height: 134px;
        display: flex;
        justify-content: space-between;
        .all_baoyang {
          height: 100%;
          width: 45%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          background: url("@/assets/other/by_bg.png") no-repeat center;
          background-size: 100% 100%;
          .icon {
            width: 1px;
            height: 50px;
          }
          .tips_box {
            width: 140px;
            height: 69px;
            display: flex;
            flex-direction: column;
            justify-content: space-between;
            .tips {
              background: url("@/assets/other/beijing.png") no-repeat center;
              background-size: 100% 100%;
              width: 100%;
              height: 24px;
              font-family: Microsoft YaHei, Microsoft YaHei;
              font-weight: 400;
              font-size: 12px;
              color: #c9eaf7;
              line-height: 24px;
              span {
                font-weight: 700;
                font-size: 12px;
                color: #09b5ff;
                margin-left: 5px;
              }
            }
            .line {
              width: 140px;
              height: 0px;
              border-bottom: 1px dashed #6e9cc5;
            }
          }
        }
        .info_box {
          flex: 1;
          margin-left: 10px;
          background: url("@/assets/other/by_bg.png") no-repeat center;
          background-size: 100% 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: space-evenly;
          .icon {
            width: 76px;
            height: 56px;
          }
          .line {
            width: 1px;
            height: 50px;
          }
          .info_desc {
            height: 56px;
            .label {
              font-weight: 700;
              font-size: 14px;
              color: #fff;
            }
            .num {
              font-family: D-DIN;
              font-weight: 700;
              font-size: 28px;
              background: linear-gradient(90deg, #00fffd 0%, #0095fa 100%);
              -webkit-background-clip: text;
              -webkit-text-fill-color: transparent;
            }
          }
        }
      }

      .center_bottom {
        width: 580px;
        height: 386px;
        position: relative;
        z-index: 99;
        padding: 20px;
        background: rgba(0, 30, 58, 0.72);
        box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
        border-radius: 0px 0px 0px 0px;
        border: 2px solid rgba(103, 192, 255, 0.46);
        .anay_box {
          width: 100%;
          height: 78px;
          display: flex;
          .anay_list {
            flex: 1;
            height: 100%;
            display: flex;
            align-items: center;
            .icon {
              width: 98px;
              height: 79px;
            }
            .desc_box {
              height: 100%;
              flex: 1;
              margin-left: 20px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              justify-content: space-between;
              .label {
                font-weight: 700;
                font-size: 18px;
                color: #fff;
              }
              .num {
                font-weight: 700;
                font-size: 30px;
                color: #4aedff;
                line-height: 40px;
                text-shadow: 0px 4px 10px #00bfff;
              }
            }
          }
        }
        .unline_title {
          width: 100%;
          display: flex;
          align-items: center;
          height: 24px;
          margin: 20px auto 10px;
          .icon {
            width: 12px;
            height: 12px;
          }
          .text {
            flex: 1;
            text-align: left;
            font-weight: 700;
            margin-left: 6px;
            font-size: 18px;
            color: #58baff;
          }
          .icon2 {
            width: 24px;
            height: 10px;
          }
        }
        .table_box {
          height: 254px;
          width: 100%;
        }
      }

      .map_box {
        position: absolute;
        top: 150px;
        bottom: 20px;
        left: 10px;
        right: 10px;
        .back {
          position: absolute;
          margin: auto;
          cursor: pointer;
          left: 0;
          top: 0;
          background: url("@/assets/image/back.png") no-repeat center;
          background-size: 100% 100%;
          width: 124px;
          height: 36px;
          z-index: 999;
        }
        .map_content {
          width: 100%;
          height: 100%;
        }
      }
    }

    .right {
      width: 480px;
      height: 100%;
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      .hetong_box {
        width: 100%;

        .hetong_content {
          background: url("@/assets/image/g1.png") no-repeat center;
          background-size: 100% 100%;
          width: calc(100% - 20px);
          height: 218px;
          padding: 20px 10px;
          display: flex;
          flex-wrap: wrap;
          position: relative;
          .heng_line {
            width: 320px;
            height: 2px;
          }
          .shu_line {
            width: 2px;
            height: 130px;
          }
          .center_line {
            position: absolute;
            margin: auto;
            left: 0;
            right: 0;
            bottom: 0;
            top: 0;
          }
          .hetong_list:nth-of-type(1) .hetong_info .num {
            color: #d01c00;
          }
          .hetong_list:nth-of-type(2) .hetong_info .num {
            color: #00cb61;
          }
          .hetong_list:nth-of-type(3) .hetong_info .num {
            color: #e2b400;
          }
          .hetong_list:nth-of-type(4) .hetong_info .num {
            color: #b0b0b0;
          }
          .hetong_list {
            width: 50%;
            height: 50%;
            display: flex;
            align-items: center;
            justify-content: center;
            .icon {
              width: 92px;
              height: 68px;
              margin-right: 10px;
            }

            .hetong_info {
              height: 68px;
              display: flex;
              flex-direction: column;
              align-items: flex-start;
              .label {
                font-weight: 700;
                font-size: 16px;
                color: #fff;
              }
              .num {
                font-family: D-DIN;
                font-weight: 700;
                font-size: 32px;
                line-height: 35px;
              }
            }
          }
        }
      }

      .baoxian_box {
        height: calc(100% - 320px);
        width: 100%;
        .baoxian_content {
          height: calc(100% - 82px);
          background: url("@/assets/other/baoxian_bg.png") no-repeat center;
          background-size: 100% 100%;
          padding: 20px;
          width: calc(100% - 40px);
          display: flex;
          flex-direction: column;
          .baoxian_top {
            width: 440px;
            height: 176px;
            background: rgba(0, 30, 58, 0.72);
            box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
            border-radius: 0px 0px 0px 0px;
            border: 1px solid rgba(103, 192, 255, 0.46);
            display: flex;
            flex-direction: column;
            align-items: center;
            justify-content: flex-end;
            .zongshu {
              background: url("@/assets/other/zongshu.png") no-repeat center;
              background-size: 100% 100%;
              width: 296px;
              height: 120px;
              display: flex;
              margin-bottom: 10px;
              flex-direction: column;
              align-items: center;
              justify-content: flex-start;
              .num {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: 36px;
                color: #09b5ff;
              }
              .label {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: 22px;
                color: #fff;
                margin-top: 10px;
              }
            }
          }

          .baoxian_bottom {
            flex: 1;
            width: 100%;
            margin-top: 20px;
            display: flex;
            justify-content: space-between;
            .bao_list {
              width: 190px;
              background: url("@/assets/other/bao_bg.png") no-repeat center;
              background-size: 100% 100%;
              display: flex;
              flex-direction: column;
              padding: 10px;
              .icon {
                width: 32px;
                height: 6px;
              }
              .label {
                font-family: YouSheBiaoTiHei;
                font-weight: 400;
                font-size: 18px;
                color: #fff;
                // margin-top: 6px;
                width: 100%;
                text-align: left;
              }
              .picture {
                width: 70px;
                height: 70px;
                margin: 0 auto 0;
              }
              .show_value {
                flex: 1;
                display: flex;
                flex-direction: column;
                justify-content: space-evenly;
                .show_list {
                  width: calc(100% - 10px);
                  height: 24px;
                  display: flex;
                  align-items: center;
                  justify-content: flex-start;
                  font-weight: 400;
                  font-size: 12px;
                  padding-left: 10px;
                  color: #fff;
                  position: relative;
                  span {
                    position: absolute;
                    margin: auto;
                    line-height: 24px;
                    left: 0;
                    right: 0;
                  }
                  &.one {
                    span {
                      font-weight: 700;
                      font-size: 12px;
                      color: #f88d3f;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(245, 140, 64, 0.2) 0%,
                      rgba(245, 140, 64, 0) 100%
                    );
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(
                          245.00000059604645,
                          140.00000685453415,
                          64.00000378489494,
                          0.05000000074505806
                        ),
                        rgba(
                          245.00000059604645,
                          140.00000685453415,
                          64.00000378489494,
                          0.47999998927116394
                        ),
                        rgba(245.00000059604645, 140.00000685453415, 64.00000378489494, 0)
                      )
                      1 1;
                  }
                  &.two {
                    span {
                      font-weight: 700;
                      font-size: 12px;
                      color: #ff403f;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(255, 64, 63, 0.26) 0%,
                      rgba(255, 64, 63, 0) 100%
                    );
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(
                          255,
                          64.00000378489494,
                          63.000000044703484,
                          0.14000000059604645
                        ),
                        rgba(
                          255,
                          64.00000378489494,
                          63.000000044703484,
                          0.6299999952316284
                        ),
                        rgba(255, 64.00000378489494, 63.000000044703484, 0)
                      )
                      1 1;
                  }
                  &.three {
                    span {
                      font-weight: 700;
                      font-size: 12px;
                      color: #f3e229;
                    }
                    background: linear-gradient(
                      270deg,
                      rgba(243, 226, 41, 0.23) 0%,
                      rgba(243, 226, 41, 0) 100%
                    );
                    border-radius: 0px 0px 0px 0px;
                    border: 1px solid;
                    border-image: linear-gradient(
                        270deg,
                        rgba(
                          243.00000071525574,
                          226.0000017285347,
                          41.00000135600567,
                          0.14000000059604645
                        ),
                        rgba(
                          243.00000071525574,
                          226.0000017285347,
                          41.00000135600567,
                          0.6899999976158142
                        ),
                        rgba(243.00000071525574, 226.0000017285347, 41.00000135600567, 0)
                      )
                      1 1;
                  }
                }
              }
            }
          }
        }
      }
    }
  }

  .large_bottom {
    background: url("@/assets/image/large_bottom_bg.png") no-repeat center;
    background-size: 100% 100%;
    width: 100%;
    height: 44px;
  }
}

.item_box {
  display: flex;
  flex-direction: column;
  width: 100%;
  .item_title_box {
    width: calc(100% - 40px);
    height: 36px;
    background: url("@/assets/image/box_title_bg.png") no-repeat center;
    background-size: 100% 100%;
    margin-bottom: 6px;
    font-family: YouSheBiaoTiHei;
    font-weight: 400;
    font-size: 24px;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    padding-left: 40px;
    &.other {
      background: url("@/assets/image/center_title_bg.png") no-repeat center;
      background-size: 100% 100%;
    }
    .tags_box {
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: space-evenly;
      .tips_view {
        display: flex;
        align-items: center;
        font-weight: 400;
        font-size: 14px;
        color: #d6cfcd;
        font-family: Microsoft YaHei;
        .icon {
          width: 16px;
          height: 16px;
          margin-right: 6px;
        }
        &.success {
          color: #34fa93;
        }
        &.warn {
          color: #fca30a;
        }
        &.danger {
          color: #ed4c33;
        }
        &.primary {
          color: #00eeff;
        }
      }
    }
  }
}

::v-deep .el-form-item {
  margin-bottom: 0 !important;

  .el-form-item__label {
    font-weight: 400;
    font-size: 14px;
    color: #b8c6d3;
    line-height: 28px;
  }
  .el-form-item__content {
    color: #09b5ff;
    line-height: 28px;
    text-align: left;
  }
}

::v-deep .el-table {
  thead {
    font-weight: 400;
    font-size: 16px;
    color: #93e4ff;
    tr {
      background: rgba(27, 123, 214, 0.15);
    }
  }
  tr {
    background: rgba(0, 30, 58, 0.72);
    // box-shadow: inset 0px 0px 15px 8px rgba(97, 179, 255, 0.17);
    border: 1px solid rgba(103, 192, 255, 0.46);
  }
}
.tableSpec {
  width: 100%;
  --el-table-border-color: rgba(222, 253, 255, 0.16);
}
:deep(.el-table) {
  background-color: transparent;
}
:deep(.el-table__expanded-cell) {
  background-color: transparent;
}

:deep(.el-table th) {
  // background-color: rgba(0, 238, 246, 0.08) !important;
  font-weight: 400;
  font-size: 14px;
  color: #a3c8e8 !important;
  background-color: transparent !important;
  //   border-top: 1px solid red;
  border-top: 1px solid #58bfff;
  // font-size: 0.06rem;
}
// 去除table表格底部白色线条
::v-deep .el-table::before {
  background-color: transparent !important;
}

::v-deep .el-table td.el-table__cell,
.el-table th.el-table__cell.is-leaf {
  border-bottom: 1px dashed #093863 !important;
}
::v-deep .el-table th.el-table__cell.is-leaf {
  border-bottom: 1px solid #58bfff;
}
::v-deep .el-table .el-table__row .el-table__cell .cell {
  color: #fff;
}

::v-deep .el-table--enable-row-hover .el-table__body tr:hover > td.el-table__cell {
  background: transparent !important;
}
// ::v-deep .el-table .el-table__row {
//   &:hover {
//     td {
//       .el-table__cell {
//         background: transparent !important;
//       }
//     }
//   }
// }
::v-deep .el-table__body-wrapper::-webkit-scrollbar {
  display: none; /* Chrome, Safari, Opera*/
}

.nothing {
  width: 40%;
  margin: auto;
}
</style>
